import React from 'react';
import MobileDeliveryHub from './mobileDeliveryHub';

const PageLivreur = () => <MobileDeliveryHub />;

export default PageLivreur;
